
export const getFullStringBase64 = (shortBase64) => {
    return `data:image/jpeg;base64,${shortBase64}`;
  };